<template>
  <Toast />
  <AdminNavBar />

  <div class="dns">
    <Card v-if="Users" class="">
        <template #title>
          <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="openNewUserModal" />
          <!-- <Button class="p-button-lg p-button-rounded p-button-text p-button-plain" icon="pi pi-cog" @click="openNewRecordModal"  v-tooltip.bottom="'Settings'"/> -->
        </template>
        <template #content>
          <DataTable :value="Users.users" class="p-datatable-sm" responsiveLayout="stack" @row-click="openUserModal($event)" rowHover stripedRows selectionMode="single">
              <template #empty>
                <span style="text-align: center">No records found</span>
              </template>
              <Column field="login" header="Login"></Column>
              <Column field="name" header="Name"></Column>
              <Column field="content" header="Contact">
                <template #body="{data}">
                  <span v-for="v, k in getAttribute(data.attributes, 'contact')" class="p-mr-2">
                    <span v-if="k == 'email'">
                      <i  class="pi pi-envelope p-pr-2" style="color:var(--blue-400)"></i>
                      <span><a :href="'mailto:' + v">{{ v }}</a></span>
                    </span>
                    <span v-if="k == 'phone'">
                      <i class="pi pi-phone p-pr-2" style="color:var(--purple-400)"></i>
                      <span>{{ v }}</span>
                    </span>
                  </span>
                </template>
              </Column>
              <Column header="2FA">
                <template #body="{data}">
                  <span v-for="v, k in getAttribute(data.attributes, 'totp')">
                    <i v-if="k == 'enabled' && v == true" class="pi pi-shield" style="color:var(--green-400)"></i>
                  </span>
                </template>
              </Column>
              <Column field="is_superadmin" header="Admin">
                <template #body="{data}">
                    <i v-if="data.is_superadmin == true" class="pi pi-bolt" style="color:var(--blue-400)"></i>
                </template>
              </Column>
              <Column header="Active" headerStyle="width: 100px; text-align: right">
                  <template #body="slotProps">
                    <i v-if="slotProps.data.is_enabled" style="color:var(--green-400)" class="pi pi-check-circle"></i>
                    <i v-else style="color:var(--orange-400)" class="pi pi-minus-circle"></i>
                  </template>
              </Column>
          </DataTable>
        </template>
    </Card>
    <div v-else>
      No users
    </div>
  </div>
  <Dialog header="New User" v-model:visible="displayNewUserModal" :modal="true">
      <div class="new-user">
          <form class="p-fluid" autocomplete="off" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="login" v-model="user.login" autocomplete="off" />
                      <label for="login">Login *</label>
                      <small class="p-error" v-if="errors.login">{{ errors.login }}</small>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="name" v-model="user.name" autocomplete="off" />
                      <label for="name">Name</label>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <Password id="password" v-model="user.password" autocomplete="off" toggleMask v-on:keyup.enter="createUser"/>
                      <label for="password">Password *</label>
                      <small class="p-error" v-if="errors.password">{{ errors.password }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="user.is_enabled"></Checkbox>
                  <label for="is_enabled">Active</label>
              </div>
              <Button label="Create" icon="pi pi-user" class="w-full" :loading="loading" @click="createUser"></Button>
          </form>
      </div>
  </Dialog>
  <Dialog :header="user.login" v-model:visible="displayUserModal" :modal="true">
      <div class="new-user">
          <form class="p-fluid" autocomplete="off" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="login" v-model="user.login" autocomplete="off" />
                      <label for="login">Login *</label>
                      <small class="p-error" v-if="errors.login">{{ errors.login }}</small>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="name" v-model="user.name" autocomplete="off" />
                      <label for="name">Name</label>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <Password id="password" v-model="user.password" autocomplete="off" toggleMask v-on:keyup.enter="saveUser"/>
                      <label for="password">Password *</label>
                      <small class="p-error" v-if="errors.password">{{ errors.password }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="user.is_enabled"></Checkbox>
                  <label for="is_enabled">Active</label>
              </div>
          </form>
          <div class="p-mb-3" v-if="errors && errors[0] && errors[0].fatal">
            <small class="p-error p-pb-4" v-if="errors[0].fatal">{{ errors[0].fatal }}</small>
          </div>
      </div>
      <template #footer>
          <Button label="Delete" class="p-button-text p-button-danger" @click="deleteUser(user)"></Button>
          <Button label="Update" :loading="loading" @click="saveUser"></Button>
      </template>
  </Dialog>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AdminNavBar from '../components/AdminNavBar.vue'

export default {
  name: 'AdminUsers',
  components: {
    AdminNavBar,
  },
  data () {
    return {
      form: {
        label: ''
      },
      loading: false,
      errors: {},
      user: {id: '', name: '', login: '', password: '', is_enabled: true},
      displayUserModal: false,
      displayNewUserModal: false,
    }
  },
  beforeMount(){
    
  },
  computed: {
    ...mapGetters({ Users: 'StateUsers'}),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  watch: {
  },
  
  created: function () {
  //  // a function to call getposts action
    //this.GetDomains()
    this.GetUsers()

  },
  methods: {
    ...mapActions(['CreateUser', 'GetUsers', 'UpdateUser', 'DeleteUser']),
    async createUser () {
      this.loading = true
      this.errors = {}
      
      this.CreateUser(this.user)
        .then(response => {
          this.displayNewUserModal = false
          this.user = {id: '', name: '', login: '', password: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'User created', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          let data = error.response.data
          Object.keys(data["detail"]).forEach(f => {
              let loc = data["detail"][f]["loc"].slice(1)
              let msg = data["detail"][f]["msg"]

              var ref = this.errors

              Object.keys(loc).forEach(i => {
                  if (i == Object.keys(loc).length - 1) {
                      ref[loc[i]] = msg
                  }
                  ref = ref[loc[i]]
                  
              })
              ref = msg
          })
          //this.errors = error.response.data.errors
        })
        .finally(() => this.loading = false)
    },
    async saveUser () {
      this.loading = true
      this.errors = {}
      
      this.UpdateUser(this.user)
        .then(response => {
          this.displayUserModal = false
          this.user = {id: '', name: '', login: '', password: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'User updated', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
        .finally(() => this.loading = false)
    },
    async deleteUser(user) {
      this.errors = {}
      
      this.$confirm.require({
          message: 'Are you sure you want to delete ' + user.login + '?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger',
          accept: () => {
            this.loading = true

            this.DeleteUser(user)
              .then(response => {
                this.displayUserModal = false
                this.$toast.add({severity:'info', summary: 'User deleted', life: 3000});
              })
              .catch(error => {
                this.errors = error.response.data.errors
              })
              .finally(() => this.loading = false)
          },
          reject: () => {
              //callback to execute when user rejects the action
          }
      });
    },
    openNewUserModal() {
      this.errors = {}
      this.user = {id: '', name: '', login: '', password: '', is_enabled: true}
      this.displayNewUserModal = true
    },
    openUserModal(e) {
      this.errors = {}
      const result = this.Users.users.find( ({ id }) => id === e.data.id );
      Object.assign(this.user, result)
      this.displayUserModal = true
    },
    getAttribute(attr, key) {
      if (attr) { 
        const result = attr.find( x => x.key === key);
        if (result) {
          return result["value"]
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.new-user {
        form {
            margin-top: 2rem;
        }

        .p-field {
            margin-bottom: 1.5rem;
        }


}
</style>
